<template>
  <component
    :is="tag"
    :class="modifierClass"
  >
    <slot />
  </component>
</template>

<script>
import form  from '@/js/util/form.js'

export default {
  provide () {
    return {
      [form]: this,
    }
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    }
  },
  data() {
    return {
      baseClass: undefined,
      modifierClass: undefined,
    }
  },
  mounted() {
    [this.baseClass] = this.$el.classList
  },
  created() {
    this.$on('state', this.setModifierClass)
  },
  methods: {
    setModifierClass(modClass) {
      this.$nextTick(() => {
        this.modifierClass = `${this.baseClass}--${modClass}`
      })
    },
  },
}
</script>
